// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
interface Props {
  onClick?: () => void;
  size?: number;
  fill?: string;
  stroke?: string;
}
export const IconDraggable: React.FC<Props> = ({
  size = 24,
  fill = 'none',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g fill="currentColor">
        <rect x="5" y="5" width="3" height="3" rx="0.5" />
        <rect x="10.5" y="5" width="3" height="3" rx="0.5" />

        <rect x="5" y="10.5" width="3" height="3" rx="0.5" />
        <rect x="10.5" y="10.5" width="3" height="3" rx="0.5" />

        <rect x="5" y="16" width="3" height="3" rx="0.5" />
        <rect x="10.5" y="16" width="3" height="3" rx="0.5" />
      </g>
    </svg>
  );
};
